
import React from "react";
import { Widget } from "../../../components/widget";
import styled from "styled-components";
import { Grid as MuiGrid } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { green } from "@material-ui/core/colors";
const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;
export const SuccessPage: React.FunctionComponent<{
}> = ({ }) => {

  return (
    <>

      <StyledWidget title="Payment Successful">

        <MuiGrid container spacing={2}>
          <MuiGrid item xs={10}>


            Purchase successful

          </MuiGrid>
          <MuiGrid item xs={2}>
            <Check style={{ color: green[500], fontSize: 70 }} />
          </MuiGrid>
        </MuiGrid>

      </StyledWidget>
    </>
  );
};
